import React from "react";
import { PAGES, PERMISSION_DATA } from "../../../lib/const";
import usePermission from "../../../lib/hooks/usePermisson";
import Content from "./components/content";
import Search from "./components/search";
import SearchCustomerPersonaProvider from "./searchContext";
import WithSidebar from "../../../templates/withSidebar";

const DashboardCustomerPersona = () => {
   const [roleUser, isAll] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.CURRENT_CUSTOMER
  );

  return (
   
      <SearchCustomerPersonaProvider>
      <Search roleUser={roleUser} />
      <Content roleUser={roleUser} />
      </SearchCustomerPersonaProvider>
 
   
  );
};

export default DashboardCustomerPersona;
